export const DISCIPLINE_EMBLEMS = {
  muaythai: { src: "/logos/emblem_muaythai_sm.webp", label: "Muay Thaï / Kickboxing" },
  bjj: { src: "/logos/emblem_bjj_sm.webp", label: "Brazilian Jiu-Jitsu RDJP" },
  canryu: { src: "/logos/emblem_canryu_sm.webp", label: "Jiu-jitsu Can Ryu" },
  powerkick: { src: "/logos/ph02_sm.webp", label: "PowerKick Her" },
};

export const MASTER_LOGO = {
  text: "/logos/master_text_sm.webp",
  pastilles: "/logos/master_pastilles_sm.webp",
  full: "/logos/master_wordmark.webp",
};

const norm = (s) => (s || "").toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export function emblemKeyFor(name) {
  const n = norm(name);
  if (!n) return null;
  if (n.includes("powerkick") || n.includes("power kick") || n.includes("pkh")) return "powerkick";
  if (n.includes("can ryu") || n.includes("can-ryu") || n.includes("canryu") || n.includes("japonais") || n.includes("jujutsu") || n.includes("samoura")) return "canryu";
  if (n.includes("bjj") || n.includes("jjb") || n.includes("bresilien") || n.includes("brazilian") || n.includes("grappling")) return "bjj";
  if (n.includes("muay") || n.includes("kick") || n.includes("boxe") || n.includes("boxing")) return "muaythai";
  return null;
}

export function emblemFor(name) {
  const k = emblemKeyFor(name);
  return k ? DISCIPLINE_EMBLEMS[k] : null;
}
